import React from "react";
import "./header.scss";
const logo = (
  <img
    className="logo"
    alt="logo"
    src={require("../../assets/header/img/logo-presto.png")}
  />
);
export { logo };
